import type { LanguageCode as BaseLanguageCode, CountryCode, LocaleCode } from '#types/locale'

type LanguageCode = BaseLanguageCode | 'gb' | 'se'

type Locale = Partial<{ [K in LocaleCode]: `${CountryCode | LanguageCode}_${Uppercase<LanguageCode>}` }>

const localeMap: Locale = {
  'de-at': 'de_DE',
  'de-be': 'de_DE',
  'de-ch': 'de_DE',
  'de-lu': 'de_DE',
  'en-cz': 'en_GB',
  'en-dk': 'en_GB',
  'en-fi': 'en_GB',
  'en-ie': 'en_GB',
  'en-lu': 'en_GB',
  'en-pt': 'en_GB',
  'en-se': 'en_GB',
  'fr-be': 'fr_FR',
  'fr-ch': 'fr_FR',
  'fr-lu': 'fr_FR',
  'it-ch': 'it_IT',
  'nl-be': 'nl_NL',
  'nl-lu': 'nl_NL',
  'sv-fi': 'sv_SE'
}

/**
 * Returns mapped locale for PowerReviews Write API
 * @param locale key used to return corresponding value
 * @example
 * const locale = 'en-us
 * getMappedLocale(locale)
 * returns 'en_US'
 * @category Utils
 */
export const getMappedLocale = (locale: LocaleCode): `${CountryCode}_${Uppercase<LanguageCode>}` | string =>
  localeMap[locale] || (locale.replace(/-(\w+)/, (_, g) => `_${g.toUpperCase()}`))
